export const headerBg = require('images/careers/headerBg.webp');
export const openPositions = require('images/careers/openPositions.webp');
export const subcontractingOpportunities = require('images/careers/subcontractingOpportunities.webp');
export const emptyCategory = require('images/careers/emptyCategory.webp');
